import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Typography } from "@mui/material";
import AddVehicleVariant from "components/Manufacturer/VehicleDetails/AddVehicleVariant";
import { ManufacturerTableApi } from "stores/ManufacturerStore/ManufacturerApi";
import VehicleVariantEditModel from "components/Manufacturer/Models/VehicleVariantEditModel";
import VehicleVariantSuccessfull from "components/Manufacturer/Models/VehicleVariantSuccessfull";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

class VehicleVariantContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      manufacturer_id: "",
      model_id: "",
      name: "",
      openSuccess: false,
      snackbar: false, // Snackbar state
    };
  }

  componentDidMount() {
    this.props.getSlectVehicleAction();
    this.props.getSlectVehicleModelAction();
    this.props.getVehicleVariantAction();
  }

  submitVehicleVariant = async (val) => {
    var res = await ManufacturerTableApi.postAddVehicleVariantApi(val);
    if (res.status === 1) {
      this.handleClickOpenSuccessMassage();
    }
    this.props.getVehicleVariantAction();
  };

  handleClickOpenSuccessMassage = () => {
    this.setState({ openSuccess: true });
  };
  handleClickCloseSuccessMassage = () => {
    this.setState({ openSuccess: false });
  };

  manufactureChange = (val) => {
    this.props.getSlectVehicleModelAction({ id: val });
  };

  handleOnChange = (e, name) => {
    if (name === "model_id") {
      this.setState({ model_id: e.target.value });
    } else if (name === "name") {
      this.setState({ name: e.target.value });
    } else if (name === "manufacturer_id") {
      this.setState({ manufacturer_id: e.target.value });
    }
  };

  handleClickEditVehicleVariantSubmit = async () => {
    const { id, model_id, name, manufacturer_id } = this.state;
    const res = await ManufacturerTableApi.UpdateAddVehicleVariant({
      id,
      name: name,
      model_id: model_id,
      manufacturer_id: manufacturer_id,
    });
    if (res.status === 1) {
      this.setState({ snackbar: true }); 
    }
    await this.props.getVehicleVariantAction();
    this.setState({ open: false });
  };

  handleClickOpenEdit = (id, name, manufacturer_id, model_id) => {
    this.setState({
      open: true,
      id: `${id}`,
      manufacturer_id: manufacturer_id,
      model_id: model_id,
      name: name,
    });
  };
  handleCloseEdit = () => {
    this.setState({ open: false });
  };

  render() {
    const selectlist = this.props?.SelectVehicleListdata?.result;
    const selecmodeltlist = this.props?.SelectVehicleModelListdata?.result;
    return (
      <Grid item xs={12}>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/manufacturer"
            >
              Manufacturer
            </Link>
            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              Add vehicle variant
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid>
          <Paper sx={{ p: 3, mt: 1 }}>
            <AddVehicleVariant
              selectlist={selectlist}
              selecmodeltlist={selecmodeltlist}
              OnmanufactureChange={this.manufactureChange}
              submitVehicleVariant={(val) => this.submitVehicleVariant(val)}
              data={this.props.vehicleVariantList}
              handleClickOpenEdit={this.handleClickOpenEdit}
              loading={this.props.isloadingvehicleVariant}
            />
          </Paper>

          <VehicleVariantEditModel
            selectlist={selectlist}
            selecmodeltlist={selecmodeltlist}
            open={this.state.open}
            OnmanufactureChange={this.manufactureChange}
            manufacturer_id={this.state.manufacturer_id}
            model_id={this.state.model_id}
            name={this.state.name}
            handleCloseEdit={this.handleCloseEdit}
            handleOnChange={(e, f) => {
              this.handleOnChange(e, f);
            }}
            handleClickEditVehicleVariantSubmit={
              this.handleClickEditVehicleVariantSubmit
            }
          />

          <VehicleVariantSuccessfull
            openSuccess={this.state.openSuccess}
            handleClickCloseSuccessMassage={this.handleClickCloseSuccessMassage}
          />

          <Snackbar
            open={this.state.snackbar}
            autoHideDuration={3000}
            onClose={() => this.setState({ snackbar: false })}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert severity="success">
              Vehicle Variant Update Successfully
            </Alert>
          </Snackbar>
        </Grid>
      </Grid>
    );
  }
}
export default VehicleVariantContainer;
